import React, { Fragment, memo } from 'react';
//Componentes
import Botones from '../../../components/UI/botonera/headerBotones.js';
import CajaTexto from '../../../components/UI/cajaTexto/cajaTexto.jsx';
import ComboBox from '../../../components/UI/comboBox/combobox.jsx';

export function mantSubTiposCuentasInt(props) {
  return (
    <Fragment>
    <div className="col-md-12">
        <div className='row'>
            <div className="col-md-6">
                <h1>{props.Titulo}</h1>
            </div>
            <div className="col-md-6 text-right">
                <div className="acciones">
                    <Botones
                        botones={props.botones}
                    />
                </div>
            </div>
        </div>
        <div className="content">
            <div className="content-box box-primary">
                <div className='row'>
                    <div className='row'>
                        <CajaTexto col="6" id="ID" type="text" label={props.Datos.ID.attributes.label} value={props.Datos.ID.value} attributes={props.Datos.ID.attributes} onChangeInput={props.onChangeInput} />
                        <CajaTexto col="6" id="Nombre" type="text" label={props.Datos.Nombre.attributes.label} value={props.Datos.Nombre.value} attributes={props.Datos.Nombre.attributes} onChangeInput={props.onChangeInput} />
                    </div>
                    <div className='row'>
                    <ComboBox id="cmbTipo" col="6" attributes={props.Datos.Tipo.attributes} value={props.selectedOptionTipo} label={props.Datos.Tipo.attributes.label} datos={props.listaSubTiposCuentasTipo} onChange={props.onhandleSelectedTipo} />
                    </div>                            


                </div>
            </div>
        </div>
    </div>

</Fragment>
  );
};
export default memo(mantSubTiposCuentasInt);